import { connect } from 'react-redux';
import { State } from 'widgets/free-content/root/root.reducers';
import ContentBanner from '../../modules/content-banner/content-banner.component';
import { IContentBannerStoreProps } from './content-banner.types';

const mapStateToProps = (state: State): IContentBannerStoreProps => ({
    shouldInheritStyles: state.config.shouldInheritStyles
});

const ContentBannerContainer = connect(mapStateToProps)(ContentBanner);

export default ContentBannerContainer;
